import styles from '@/assets/styles/pages/competition/competition.module.scss';
import React, { useRef } from 'react';
import FashButton from '@/components/FashButton';
import { MimaText, MimaButton } from '@/components';
import { useSwitchNav } from '@/components/PageLayout/_PageLayoutComponents/SwitchNav';
import { useInView } from 'framer-motion';

interface CompetitionsProps {
  competitionList: any;
}

const Prize: React.FC<CompetitionsProps> = ({ competitionList }) => {
  const { switchToLogin, switchToSignup } = useSwitchNav();
  const imageRef = useRef(null);
  const imageIsInView = useInView(imageRef, { once: true, amount: 0.5 });
  const currentCompetition = competitionList?.filter((item: any) => item?.status === 'ACTIVE').map((competition: any) => competition)?.[0];

  const prizes = [
    {
      prize: 1,
      title: 'WINNER',
      prizeKey1: 'Cash Prize',
      prizeKey2: 'Fash Subscription',
      prizeKey3: 'Quality yarn from Hookedbylade',
      prizeValue1: 'NGN500,000',
      prizeValue2: 'Annual subscription',
    },
    {
      prize: 2,
      title: '1st Runner-up',
      prizeKey1: 'Cash Prize',
      prizeKey2: 'Fash Subscription',
      prizeKey3: 'Quality yarn from Hookedbylade',
      prizeValue1: 'NGN150,000',
      prizeValue2: 'Bi-annual Subscription',
    },
    {
      prize: 3,
      title: '2nd Runner-up',
      prizeKey1: 'Cash Prize',
      prizeKey2: 'Fash Subscription',
      prizeKey3: 'Quality yarn from Hookedbylade',
      prizeValue1: 'NGN50,000',
      prizeValue2: 'Quarterly Subscription',
    },
  ];

  return (
    <section className={styles.prize}>
      <div className={styles.container}>
        <MimaText variant="h2" align="center" className={styles.titleText}>
          STAND A CHANCE TO BE THE <br /> <span>ULTIMATE CROCHETIERE</span>
        </MimaText>

        {prizes.map((prize) => {
          return (
            <div className={styles.prizeCard} key={prize.prize}>
              <div className={styles.prizeCardTitle}>
                <MimaText variant="h4">{prize.title}</MimaText>
              </div>
              <div className={styles.prizeList}>
                <div>
                  <ul>
                    <li>{prize.prizeKey1}</li>
                    <li>{prize.prizeKey2}</li>
                    <li>{prize.prizeKey3}</li>
                  </ul>
                </div>

                <div>
                  <ul>
                    <li>{prize.prizeValue1}</li>
                    <li>{prize.prizeValue2}</li>
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
        <div className={styles.buttonSet}>
          <FashButton title="Learn More" icon color="var(--color-dark)" onClick={switchToSignup} />
          <MimaButton variant="outlined" title="Register" onClick={switchToLogin} width={18} height={5.8} />
        </div>
      </div>
    </section>
  );
};

export default Prize;
